<div class="checkout-container">
  <header>
    <h1>ZUR KASSE</h1>
    <a routerLink="/shop" class="back-link">← Zurück zum Shop</a>
  </header>

  <div class="checkout-content">
    <div class="checkout-form">
      <form [formGroup]="checkoutForm">
        <div class="step">
          <h2>Ihre Angaben</h2>
          
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Vorname</mat-label>
              <input matInput formControlName="firstName" required>
              <mat-error *ngIf="checkoutForm.get('firstName')?.invalid">
                {{ getErrorMessage('firstName') }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nachname</mat-label>
              <input matInput formControlName="lastName" required>
              <mat-error *ngIf="checkoutForm.get('lastName')?.invalid">
                {{ getErrorMessage('lastName') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>E-Mail</mat-label>
              <input matInput type="email" formControlName="email" required>
              <mat-error *ngIf="checkoutForm.get('email')?.invalid">
                {{ getErrorMessage('email') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="street">
              <mat-label>Straße</mat-label>
              <input matInput formControlName="street" required>
              <mat-error *ngIf="checkoutForm.get('street')?.invalid">
                {{ getErrorMessage('street') }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="street-number">
              <mat-label>Hausnummer</mat-label>
              <input matInput formControlName="streetNumber" required>
              <mat-error *ngIf="checkoutForm.get('streetNumber')?.invalid">
                {{ getErrorMessage('streetNumber') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>PLZ</mat-label>
              <input matInput formControlName="zipCode" required>
              <mat-error *ngIf="checkoutForm.get('zipCode')?.invalid">
                {{ getErrorMessage('zipCode') }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Stadt</mat-label>
              <input matInput formControlName="city" required>
              <mat-error *ngIf="checkoutForm.get('city')?.invalid">
                {{ getErrorMessage('city') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Land</mat-label>
              <mat-select formControlName="country" required>
                <mat-option value="DE">Deutschland</mat-option>
                <mat-option value="AT">Österreich</mat-option>
                <mat-option value="CH">Schweiz</mat-option>
                <mat-option value="US">USA</mat-option>
                <mat-option value="CA">Canada</mat-option>
                <mat-option value="GB">England</mat-option>
              </mat-select>
              <mat-error *ngIf="checkoutForm.get('country')?.invalid">
                {{ getErrorMessage('country') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Mobiltelefon</mat-label>
              <input matInput formControlName="mobile" required>
              <mat-error *ngIf="checkoutForm.get('mobile')?.invalid">
                {{ getErrorMessage('mobile') }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="payment-plan-section">
            <h3>Zahlungsplan</h3>
            <mat-form-field appearance="outline">
              <mat-label>Zahlungsplan wählen</mat-label>
              <mat-select formControlName="paymentPlan">
                <mat-option *ngFor="let plan of paymentPlans" [value]="plan.months">
                  {{plan.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="checkoutForm.get('paymentPlan')?.value > 0" class="payment-start-section">
              <mat-form-field appearance="outline">
                <mat-label>Zahlungseinzug ab</mat-label>
                <mat-select formControlName="paymentStartDate" required>
                  <mat-option [value]="0">
                    Heute starten
                  </mat-option>
                  <mat-option *ngFor="let date of paymentStartDates" [value]="date.value">
                    {{date.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="payment-actions">
            <mat-checkbox formControlName="acceptTerms" required>
              Ich habe die <a class="links" href="/agb" target="_blank">AGB</a> und die <a class="links" href="/datenschutz" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiere diese.
            </mat-checkbox>

            <mat-checkbox formControlName="acceptWithdrawalWaiver" required>
              Ich stimme ausdrücklich zu, dass HorizonNet Consulting e.U. vor Ablauf der Widerrufsfrist mit der Ausführung des digitalen Inhalts beginnt. Ich nehme zur Kenntnis, dass ich dadurch mein <a class="links" href="/widerruf" target="_blank">Widerrufsrecht</a> verliere.
            </mat-checkbox>

            <mat-checkbox *ngIf="checkoutForm.get('paymentPlan')?.value > 0" formControlName="acceptPaymentDate" required>
              <span *ngIf="checkoutForm.get('paymentStartDate')?.value === 0">
                Ich bestätige, dass der Vertrag heute beginnt und die erste Zahlung heute erfolgt.
              </span>
              <span *ngIf="checkoutForm.get('paymentStartDate')?.value !== 0">
                Ich bestätige, dass der Vertrag heute beginnt und die erste Zahlung am {{getSelectedPaymentDate() | date:'dd.MM.yyyy'}} erfolgt.
              </span>
            </mat-checkbox>

            <mat-checkbox formControlName="newsletter">
              Ja, ich möchte den Newsletter abonnieren und über Neuigkeiten und Angebote informiert werden.
            </mat-checkbox>

            <mat-checkbox *ngIf="hasHorizonAcademy()" formControlName="becomePartner">
              Ja, ich möchte Vertriebspartner werden
            </mat-checkbox>

            <div class="error-message" *ngIf="paymentError">
              {{paymentError}}
            </div>

            <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isProcessing || !checkoutForm.valid">
              <span *ngIf="!isProcessing">Jetzt kostenpflichtig bestellen</span>
              <span *ngIf="isProcessing">Bitte warten...</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="cart-summary">
      <div class="summary-card">
        <h3>WARENKORB ZUSAMMENFASSUNG</h3>
        
        <div class="summary-content">
          <h4>heutige Auftrage:</h4>
          
          <div class="product-list">
            <div class="product-item" *ngFor="let product of cartProducts">
              <img [src]="product.image" [alt]="product.name">
              <div class="product-details">
                <h5>{{ product.name }}</h5>
                <div class="price">€ {{ product.price | number:'1.2-2' }}</div>
              </div>
            </div>
          </div>

          <div class="summary-totals">
            <div class="total-row">
              <span>Zwischensumme:</span>
              <span>€ {{ fullTotal | number:'1.2-2' }}</span>
            </div>

            <div class="tax-note">
              <small>* Steuern werden beim Checkout berechnet</small>
            </div>

            <div class="total-row grand-total">
              <span>Gesamt:</span>
              <span>€ {{ fullTotal | number:'1.2-2' }}*</span>
            </div>

            <div class="total-row" *ngIf="checkoutForm.get('paymentPlan')?.value > 0">
              <span>LAUFZEIT:</span>
              <span>{{ checkoutForm.get('paymentPlan')?.value }} Monate</span>
            </div>
            
            <div class="payment-schedule-link" *ngIf="checkoutForm.get('paymentPlan')?.value > 0">
              <button mat-button class="learn-more-btn" (click)="openPaymentSchedule()">
                <mat-icon>calendar_today</mat-icon>
                Dein Zahlungsplan
              </button>
            </div>

            <div class="total-row" *ngIf="checkoutForm.get('paymentPlan')?.value > 0">
              <span>Monatliche Rate:</span>
              <span>€ {{ monthlyTotal | number:'1.2-2' }}*</span>
            </div>
          </div>
        </div>
      </div>
    </div>

 
  </div>
</div> 

<style>
.card-element-container {
  padding: 20px;
  border: 1px solid #444;
  border-radius: 4px;
  background-color: #2d2d2d;
  margin-bottom: 20px;
  min-height: 40px;
}

.stripe-card-element {
  width: 100%;
  padding: 10px;
  background-color: #2d2d2d;
  min-height: 20px;
  color: #ffffff;
}

.error-message {
  color: #fa755a;
  margin-top: 10px;
}

/* Stripe iframe specific styles */
.stripe-card-element iframe {
  color: #ffffff !important;
  background-color: #2d2d2d !important;
}
</style> 